"use strict";
import helpers from "./_helpers";

const News = () => {
    const init = () => {
        $(document).ready(function() {
            let el = document.getElementById('news');
            if (el) {
                let $form = $(el),
                  $sort = $form.find('#sort'),
                  $category = $form.find('#category'),
                  $dataContainer = $('#news-list');

                $category.change(function() {
                    let val = $(this).val();
                    // Update value
                    $("input[name='category']").val(val);

                    // Submit form to trigger ajax
                    $form.submit();

                    // Update visual states
                    $category.find('a.active').removeClass('active');
                    $form.find("a[data-category='" + val + "']").addClass('active');

                    if (val === "all") {
                        $category.parents('.form-group').removeClass('filled');
                        $category.parents('.form-group').removeClass('focused');
                        helpers.deleteUrlParameter('category');
                    } else {
                        helpers.setUrlParameter('category', val);
                    }
                });

                $sort.change(function() {
                    let val = $(this).val();
                    // Update value
                    $("input[name='sort']").val(val);

                    // Submit form to trigger ajax
                    $form.submit();

                    // Update visual states
                    $sort.find('a.active').removeClass('active');
                    $form.find("a[data-sort='" + val + "']").addClass('active');

                    if (val === "all") {
                        $sort.parents('.form-group').removeClass('filled');
                        $sort.parents('.form-group').removeClass('focused');
                        helpers.deleteUrlParameter('sort');
                    } else {
                        helpers.setUrlParameter('sort', val);
                    }
                });

                const pagination = () => {
                    $('.pagination a').each(function() {
                        $(this).click(function(e) {
                            e.preventDefault();
                            let href = $(this).attr('href');
                            let pageRegex = /page=(?<page>[0-9]+)/;
                            let groups = href.match(pageRegex).groups;
                            let page = groups.page;

                            if ($(this).attr('href') != '#') {
                                let navheight = $('header .navbar').outerHeight();
                                let top = $dataContainer.offset().top - navheight;
                                $("html, body").animate({scrollTop: top}, "fast");
                                // Update value
                                $("input[name='page']").val(page);
                                // Submit form to trigger ajax
                                $form.submit();

                                if (page === 1) {
                                    helpers.deleteUrlParameter("page");
                                } else {
                                    helpers.setUrlParameter("page", page);
                                }
                            }
                        });
                    });
                };

                $form.on('ajaxDone', function() {
                    pagination();
                });

                $dataContainer.addClass('loaded');
                pagination();
            }
        });
    };

    return {
        init:init
    };
};

export default News;